import { useCallback } from 'react';

import type { ChangeEvent } from 'react';

import { Input } from '@/ui/Input';

import { Wrapper } from '../shared';

const Widget = ({
	disabled,
	formContext,
	id,
	name,
	onBlur,
	onChange,
	onFocus,
	options,
	placeholder,
	readonly,
	value,
}) => {
	const { readonlyAsDisabled = true } = formContext;

	const handleChange = useCallback(({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
		onChange(currentTarget.value === '' ? options.emptyValue : currentTarget.value);
	}, []);

	const handleBlur = useCallback(({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
		onBlur(id, currentTarget.value);
	}, []);

	const handleFocus = useCallback(({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
		onFocus(id, currentTarget.value);
	}, []);

	return (
		<Input
			disabled={disabled || (readonlyAsDisabled && readonly)}
			id={id}
			name={name}
			onBlur={!readonly ? handleBlur : undefined}
			onChange={!readonly ? handleChange : undefined}
			onFocus={!readonly ? handleFocus : undefined}
			placeholder={placeholder}
			type="email"
			value={value}
		/>
	);
};

const EmailWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { EmailWidget };
